import { useEffect, useState } from 'react';
import { mixpanel } from '@fiverr-private/obs';
import { Step } from '../../constants';
import { useBriefCreationContext } from '../../context/BriefCreationContext';

interface UseMixpanelRecordingOptions {
    enabled?: boolean;
}

export const useMixpanelRecording = ({ enabled = false }: UseMixpanelRecordingOptions = {}) => {
    const [isRecordingWithMixpanel, setIsRecordingWithMixpanel] = useState(false);

    const { rollouts = {}, currentStep, isOpen } = useBriefCreationContext();
    const { inMustangsMixpanelRecording } = rollouts;

    const isRecordingAllowed = enabled || Boolean(inMustangsMixpanelRecording);

    const shouldStartRecording = enabled ? true : currentStep === Step.Edit;
    const shouldStopRecording = !isOpen || (!enabled && currentStep === Step.Finish);

    useEffect(() => {
        if (isRecordingAllowed && shouldStartRecording && !isRecordingWithMixpanel) {
            mixpanel.startSessionRecording();
            setIsRecordingWithMixpanel(true);
        }
    }, [isRecordingAllowed, shouldStartRecording, isRecordingWithMixpanel]);

    useEffect(() => {
        if (isRecordingAllowed && isRecordingWithMixpanel && shouldStopRecording) {
            mixpanel.stopSessionRecording();
            setIsRecordingWithMixpanel(false);
        }
    }, [isRecordingAllowed, isRecordingWithMixpanel, shouldStopRecording]);
};
